import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AseguradorasService } from './shared/aseguradoras.service';
import { ToastrService } from 'ngx-toastr';
import 'datatables.net';
import 'datatables.net-bs4';
import { Aseguradoras } from './shared/aseguradoras.model';
import * as $ from 'jquery';

@Component({
  selector: 'app-aseguradoras',
  templateUrl: './aseguradoras.component.html',
  styleUrls: ['./aseguradoras.component.css']
})
export class AseguradorasComponent implements OnInit {

  datatable: any;

  ListAseguradoras: Aseguradoras[] = [];

  constructor(private aseguradoraService: AseguradorasService,
    private toastr: ToastrService,
    private chRef: ChangeDetectorRef) { }
  
  ngOnInit() {
    this.getAseguradoras();
    //this.refreshList();
  }

  refreshList() {
    this.aseguradoraService.getAseguradoras();
  }

  getAseguradoras() {
    this.aseguradoraService.getAseguradoras().then(
      (r: Aseguradoras[]) => {
        if ($.fn.dataTable.isDataTable('#datatable')) {
          this.datatable.destroy();
        }

        //this.ListAseguradoras = r as Aseguradoras[];
        this.ListAseguradoras = this.aseguradoraService.listAseguradora as Aseguradoras[];
        
        this.chRef.detectChanges();

        const table: any = $('#datatable');
        this.datatable = table.DataTable({
          responsive: true
        });
      }
    );
  }

  updateAseguradoras() {
    this.aseguradoraService.updateAseguradoras().then(r => { this.toastr.success("Ok!"); this.refreshList() });
  }
}
